module.exports = __webpack_public_path__ + "static/media/Portugal - PT.f1870364.png";